import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconArrowRight', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M1.00003 8.99999L12.586 8.99999L10.293 11.293C9.90203 11.684 9.90203 12.316 10.293 12.707C10.684 13.098 11.316 13.098 11.707 12.707L15.706 8.70799C15.799 8.61599 15.872 8.50499 15.923 8.38199C16.024 8.13799 16.024 7.86199 15.923 7.61799C15.872 7.49499 15.799 7.38399 15.706 7.29199L11.707 3.29299C11.512 3.09799 11.256 2.99999 11 2.99999C10.744 2.99999 10.488 3.09799 10.293 3.29299C9.90203 3.68399 9.90203 4.31599 10.293 4.70699L12.586 6.99999L1.00003 6.99999C0.447029 6.99999 2.86102e-05 7.44699 2.86102e-05 7.99999C2.86102e-05 8.55299 0.447029 8.99999 1.00003 8.99999Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M1.00003 11L16.586 11L12.293 15.293C11.902 15.684 11.902 16.316 12.293 16.707C12.684 17.098 13.316 17.098 13.707 16.707L19.706 10.708C19.799 10.616 19.872 10.505 19.923 10.382C20.024 10.138 20.024 9.862 19.923 9.618C19.872 9.495 19.799 9.384 19.706 9.292L13.707 3.293C13.512 3.098 13.256 3 13 3C12.744 3 12.488 3.098 12.293 3.293C11.902 3.684 11.902 4.316 12.293 4.707L16.586 9L1.00003 9C0.447029 9 2.86102e-05 9.447 2.86102e-05 10C2.86102e-05 10.553 0.447029 11 1.00003 11Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M1.19997 13.2L19.9032 13.2L14.7516 18.3516C14.2824 18.8208 14.2824 19.5792 14.7516 20.0484C15.2208 20.5176 15.9792 20.5176 16.4484 20.0484L23.6472 12.8496C23.7588 12.7392 23.8464 12.606 23.9076 12.4584C24.0288 12.1656 24.0288 11.8344 23.9076 11.5416C23.8464 11.394 23.7588 11.2608 23.6472 11.1504L16.4484 3.9516C16.2144 3.7176 15.9072 3.6 15.6 3.6C15.2928 3.6 14.9856 3.7176 14.7516 3.9516C14.2824 4.4208 14.2824 5.1792 14.7516 5.6484L19.9032 10.8L1.19997 10.8C0.536375 10.8 -2.52725e-05 11.3364 -2.52725e-05 12C-2.52725e-05 12.6636 0.536375 13.2 1.19997 13.2Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M1.59999 17.6L26.5376 17.6L19.6688 24.4688C19.0432 25.0944 19.0432 26.1056 19.6688 26.7312C20.2944 27.3568 21.3056 27.3568 21.9312 26.7312L31.5296 17.1328C31.6784 16.9856 31.7952 16.808 31.8768 16.6112C32.0384 16.2208 32.0384 15.7792 31.8768 15.3888C31.7952 15.192 31.6784 15.0144 31.5296 14.8672L21.9312 5.26879C21.6192 4.95679 21.2096 4.79999 20.8 4.79999C20.3904 4.79999 19.9808 4.95679 19.6688 5.26879C19.0432 5.89439 19.0432 6.90559 19.6688 7.53119L26.5376 14.4L1.59999 14.4C0.715189 14.4 -1.09675e-05 15.1152 -1.09675e-05 16C-1.09675e-05 16.8848 0.715189 17.6 1.59999 17.6Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));